import axios from "axios";

const CHECK_CUSTOMER_ENDPOINT =
  "https://demo.digione.com.au/api/v1/integration/check-customer";
const INTEGRATION_KEY =
  "d8a4f2c9e7b1a5f6c0e9d4b7a3c8f2e1a9d6b5c4e0f7a8d2b9c1e5f3a6d7c4e8b0f2a9c5d1e6b7a3";

export async function checkCustomerByPhone(phoneNumber) {
  const response = await axios.post(
    CHECK_CUSTOMER_ENDPOINT,
    {
      identifier: phoneNumber,
      identifier_type: "phone",
    },
    {
      timeout: 15000,
      headers: {
        "Content-Type": "application/json",
        "X-Integration-Key": INTEGRATION_KEY,
      },
    },
  );

  return response.data;
}
